import { AjaxError } from '@api/util';
import html from './template.html';

const template = document.createElement('template');
template.innerHTML = html;

/**
 * Banner element that responds on the scrolling of the document.
 * @extends HTMLElement
 */
customElements.define(
    'occasions-overview',
    class OccasionsOverviewElement extends HTMLElement {
        /**
         * The API for the brands and models data.
         */
        static get api()
        {
            return {
                RESULT: '/wp-json/occasion-picker/v1/multisearch',
            };
        }

        constructor()
        {
            super();

            const shadow = this.attachShadow({ mode: 'open' });
            shadow.append(template.content.cloneNode(true));

            /**
             * This creates a "store-like" object which enables us to run
             * functions whenever a certain key is changed.
             *
             * For example. Whenever we modify this.data.brands, the "set"
             * method will run and do the default behavior of setting a property
             * on an object with the additional features of calling our own functions.
             */
            this.data = new Proxy(
                {
                    searchRequests: [],
                    count: [],
                    loadingCount: false,
                },
                {
                    set: (state, key, values) => {
                        Reflect.set(state, key, values);

                        switch (key) {
                            case 'result':
                                this.renderOccasions();
                                break;
                            case 'button':
                                this.renderButton();
                                break;
                        }

                        return true;
                    },
                }
            );
        }

        /**
         * Gets and sets the loading-label attribute.
         * @property
         */
        get loadingLabel()
        {
            return this.getAttribute('loading-label');
        }

        /**
         * Gets and sets the loading-label attribute.
         * @property
         */
        get searchRequests()
        {
            return this.getAttribute('search-requests');
        }

        /**
         * Gets and sets the loading-label attribute.
         * @property
         */
        get buttonSearchRequest()
        {
            return this.getAttribute('btn-search-request');
        }

        set loadingLabel(value)
        {
            if ('string' === typeof value) {
                this.setAttribute('loading-label', value);
            }
        }

        renderLinkIcon(node)
        {
            const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            const iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('viewBox', '0 0 731 25');
            iconSvg.setAttribute('preserveAspectRatio', 'xMidYMax meet');

            iconPath.setAttribute(
                'd',
                'M0 0v25h731V0c-88.318 13.333-210.318 20-366 20S87.652 13.333 0 0Z'
            );
            iconPath.setAttribute('fill', '#FFF');
            iconPath.setAttribute('fill-rule', 'evenodd');

            iconSvg.appendChild(iconPath);

            return node.appendChild(iconSvg);
        }

        /**
         * Returns the elements assigned to the occasions slot.
         * @property
         */
        get occasionsSlotElements()
        {
            const slot = this.shadowRoot.querySelector('slot[name=occasions]');
            return slot.assignedElements();
        }


        /**
         * Returns the elements assigned to the occasions slot.
         * @property
         */
        get buttonSlotElement()
        {
            const slot = this.shadowRoot.querySelector('slot[name=button]');
            return slot.assignedElements();
        }



        /**
         * Create occasions element.
         */
        renderButton() {
            const buttonSlotElement = this.buttonSlotElement[0];

            if (buttonSlotElement === undefined) {
                return;
            }

            buttonSlotElement.innerHTML = '';

            const button = this.data.button[0];

            if(button) {
                const ButtonElWrapper = buttonSlotElement.appendChild(document.createElement("div"));
                ButtonElWrapper.setAttribute("class", "w-100 mt-4 d-flex");
                const ButtonElement = ButtonElWrapper.appendChild(document.createElement("a"));
                ButtonElement.setAttribute("class", "mx-auto btn btn--secondary");
                ButtonElement.innerText = button.button_text + ' (' + button.count + ')';
                ButtonElement.setAttribute("href", button.query);
                ButtonElement.setAttribute("target", "_blank");
            }
        }

        /**
         * Create occasions element.
         */
        renderOccasions()
        {
            const OccasionsElement = this.occasionsSlotElements[0];

            if (OccasionsElement === undefined) {
                return;
            }

            // First remove placeholder
            OccasionsElement.innerHTML = '';

            for (const occasion of this.data.result) {
                const { result, count, query, button_text } = occasion;

                if (!result) {
                    continue;
                }

                // const slideElWrapper = document.createElement("div");
                // slideElWrapper.setAttribute("class", "swiper-slide");
                // const occasionElWrapper = slideElWrapper.appendChild(document.createElement("div"));

                const occasionElWrapper = document.createElement("div");
                occasionElWrapper.setAttribute("class", "op-card op-card--related");

                const occasionInnerEl = occasionElWrapper.appendChild(document.createElement("div"));
                occasionInnerEl.setAttribute("class", "op-card__link op-card__inner");

                const mediaEl = occasionInnerEl.appendChild(document.createElement("div"));
                mediaEl.setAttribute("class", "op-card__media");

                const linkUrl = result.brand + '-' +result.model + '-' + result.type;
                const cleanUrl = '/occasion/' + result.id.carId + '/' + linkUrl.replace(/\W+(?!$)/g, "-").toLowerCase()

                const figureLinkEl = mediaEl.appendChild(document.createElement("a"));
                figureLinkEl.setAttribute("href", cleanUrl);

                const figureEl = figureLinkEl.appendChild(document.createElement("figure"));
                figureEl.setAttribute("class", "op-card__image");

                if (result.extraFields.isAdapted === true && new Date().getFullYear() - result.year <= 5) {
                    const leaseEl = figureEl.appendChild(document.createElement("span"));
                    leaseEl.setAttribute("class", "op-label-private-lease");
                    leaseEl.innerText = 'Lease mogelijk';
                }

                const imgEl = figureEl.appendChild(document.createElement("img"));

                figureEl.appendChild(document.createElement("a"));

                imgEl.src = result.imageUrls[0] + '?w=600&fm=webp&q=75';

                // const occasionElSvg = figureEl.appendChild(document.createElement("svg"));
                this.renderLinkIcon(figureEl);

                const adjustableEl = mediaEl.appendChild(document.createElement("modal-trigger"));
                adjustableEl.setAttribute("id", "adjustable-trigger");

                const adjustableBtnEl = adjustableEl.appendChild(document.createElement("button"));
                const infoIcon = document.createElement("i");
                infoIcon.setAttribute("class", "fas fa-info-circle");

                if (result.extraFields.isAdapted === true ) {
                    adjustableEl.setAttribute("modal-id", "adjustable-modal-true");
                    adjustableBtnEl.setAttribute("class", "op-card__label adjusted label-result");
                    adjustableBtnEl.innerText = 'Aangepast';
                } else {
                    adjustableEl.setAttribute("modal-id", "adjustable-modal-false");
                    adjustableBtnEl.setAttribute("class", "op-card__label adaptable label-result");
                    adjustableBtnEl.innerText = 'Aanpasbaar';
                }

                adjustableBtnEl.appendChild(infoIcon);

                const occasionElContent = occasionInnerEl.appendChild(document.createElement("div"));
                occasionElContent.setAttribute("class", "op-card__content");

                const occasionElTitle = occasionElContent.appendChild(document.createElement("h4"));
                occasionElTitle.setAttribute("class", "op-card__title");
                occasionElTitle.innerText = result.brand + ' ' + result.model;

                if (result.type) {
                    const occasionElSubTitle = occasionElContent.appendChild(document.createElement("p"));
                    occasionElSubTitle.setAttribute("class", "op-card__subtitle");
                    occasionElSubTitle.innerText = result.type;
                }

                const occasionElType = occasionElContent.appendChild(document.createElement("p"));
                occasionElType.setAttribute("class", "op-card__type");
                const extraInfo = [result.mileage.toLocaleString() + ' km', result.year, result.transmissionName, result.extraFields.vehiclePurpose];
                occasionElType.innerText = extraInfo.join(' • ');

                if (result.price) {
                    const occasionElPrice = occasionElContent.appendChild(document.createElement("p"));
                    occasionElPrice.setAttribute("class", "op-card__price price price--card");
                    occasionElPrice.innerText = '€ ' + result.price.toLocaleString();
                }

                const occasionElActions = occasionInnerEl.appendChild(document.createElement("div"));
                occasionElActions.setAttribute("class", "op-card__actions");

                const occasionElButton = occasionElActions.appendChild(document.createElement("a"));

                const button_type = result.extraFields.isAdapted === true ? 'adjusted' : 'adaptable';

                occasionElButton.setAttribute("class", "op-card__button btn btn-" + button_type);
                occasionElButton.setAttribute("href", cleanUrl);
                occasionElButton.innerText = 'Bekijk deze auto';

                OccasionsElement.appendChild(occasionElWrapper);

                if (button_text) {
                    const ButtonElement = occasionElActions.appendChild(document.createElement("a"));
                    ButtonElement.setAttribute("class", "btn btn--secondary w-100");
                    ButtonElement.innerText = button_text + ' (' + count + ')';
                    ButtonElement.setAttribute("href", query);
                    ButtonElement.setAttribute("target", "_blank");
                }
            }
        }



        /**
         * Fires when the element has been connected.
         *
         * @method  connectedCallback
         * @returns {void}
         */
        async connectedCallback()
        {

            if (this.loadingLabel === null || this.loadingLabel === '') {
                this.loadingLabel = "Zoeken naar auto's..";
            }

            this.getOccasions({
                searchRequests: this.buttonSearchRequest,
            }).then(result => {
                this.data.button = result;
            });

            this.getOccasions({
                searchRequests: this.searchRequests,
            }).then(result => {
                this.data.result = result;
            }).finally(() => {
                this.data.loadingCount = false;
            });
        }

        /**
         * Fires when the element has been disconnected.
         *
         * @method  disconnectedCallback
         * @returns {void}
         */
        disconnectedCallback()
        {}

        /**
         * Get the amount of occasions.
         *
         * @param {object} options
         * @returns {number}
         */
        async getOccasions({ searchRequests = null } = {})
        {

            try {
                const response = await fetch(
                    OccasionsOverviewElement.api.RESULT,
                    {
                        method: 'POST',
                        body: searchRequests,
                    }
                );

                if (!response.ok) {
                    throw new AjaxError(
                        `Fetching data from ${OccasionsOverviewElement.api.RESULT} caused an error.`,
                        response
                    );
                }

                const { success, data } = await response.json();

                if (success === true) {
                    return data;
                }

                return {};
            } catch (error) {
                console.log(error);
                console.warn(error);
            }
        }
    }
);



// WEBPACK FOOTER //
// ./scripts/web-components/occasions-overview/index.js